import { atom, useAtom } from 'jotai';

export const workspaceModalState = atom(false);
export const channelModalState = atom(false);
export const partnerModalState = atom(false);
export const useCreateWorkspaceModal = () => {
    const [openWorkspaceCreateModal, setOpenWorkspaceCreateModal] =
        useAtom(workspaceModalState);
    return {
        openWorkspaceCreateModal,
        setOpenWorkspaceCreateModal,
    };
};

export const useCreateChannelModal = () => {
    const [openChannelCreateModal, setOpenChannelCreateModal] =
        useAtom(channelModalState);
    return {
        openChannelCreateModal,
        setOpenChannelCreateModal,
    };
};

export const useCreatePartnerModal = () => {
    const [openPartnerCreateModal, setOpenPartnerCreateModal] =
        useAtom(partnerModalState);
    return {
        openPartnerCreateModal,
        setOpenPartnerCreateModal,
    };
};
